<template lang="pug">
.filter-chart
  el-tabs(v-if='presets', v-model='inner_current')
    el-tab-pane(v-for='preset in presets', :label='preset.label', :name='preset.key', :key='preset.key')
  chart(ref='chart', :type='type', :data='data', :options='options', :height='height', :width='width', :shows='shows')
</template>

<script>
import Chart from './Chart.vue'

export default {
  name: 'filter-chart',
  props: {
    data: Object,
    options: Object,
    type: String,
    width: Number,
    height: Number,
    presets: Array,
    current: String,
  },
  components: { Chart },
  data() {
    return {
      inner_current: null,
    }
  },
  watch: {
    current() {
      this.inner_current = this.current
    },
    inner_current() {
      this.$emit('update:current', this.inner_current)
    },
  },
  mounted() {
    this.inner_current = this.current
  },
  computed: {
    chart() {
      return this.$refs.chart.chart
    },
    shows() {
      if (this.presets)
        return (this.presets.filter(p => p.key === this.inner_current)[0] || {}).shows || null
      return null
    },
  },
  methods: {
  },
}
</script>



// WEBPACK FOOTER //
// FilterChart.vue?74875a6d